/**
 * Shared feed/lesson video-layout constants.
 *
 * Kept in its own (component-free) module so VideoLayout.tsx can stay a
 * component-only file — a module that exports BOTH a component and a plain
 * constant breaks React Fast Refresh, which silently leaves the page running a
 * stale bundle after edits.
 */

/** Max width of the video column — ~80% of viewport height so a portrait 9:16
 *  frame never overflows the viewport on wide desktops. */
export const VIDEO_MAX_W = "max-w-[80dvh]";

export type VideoSource = "youtube" | "cloudflare";

/**
 * The source a clip will initially play from, derived synchronously from its
 * metadata — mirrors VideoPlayer's own `initialSource`. Lets the layout pick
 * portrait-vs-landscape correctly on the FIRST render (before the player calls
 * `onSourceResolved`), so a landscape YouTube clip doesn't briefly flash the
 * portrait column while the resolved source is still null.
 */
export function resolveVideoSource(
  activity:
    | { youtubeId?: string; cloudflareId?: string; player?: string }
    | null
    | undefined,
): VideoSource | null {
  if (!activity) return null;
  const { youtubeId, cloudflareId, player } = activity;
  if (player === "cloudflare" && cloudflareId) return "cloudflare";
  if (youtubeId) return "youtube";
  if (cloudflareId) return "cloudflare";
  return "youtube";
}
